import React, { useMemo } from 'react';
import Table from './Tables';

const innerColumns = [
  { name: 'Type', selector: (row) => row.name, sortable: false },
  { name: 'Count', selector: (row) => row.value, sortable: true },
];

const MessageExpandableRow = ({ data }) => {
  const messages = data?.messages || {};

  const innerRows = useMemo(() => {
    if (!messages) return [];

    const keys = [
      { key: 'total_messages', name: 'Total' },
      { key: 'input_messages', name: 'Input' },
      { key: 'output_messages', name: 'Output' },
      { key: 'is_sent', name: 'Sent' },
      { key: 'is_redacted', name: 'Redacted' },
    ];

    return keys.map((k) => ({
      name: k.name,
      value: messages[k.key] ?? 0,
    }));
  }, [messages]);

  if (!innerRows.length) {
    return (
      <div className="table-folded-content" style={{ padding: '8px 12px' }}>
        <em>No messages</em>
      </div>
    );
  }

  return (
    <div className="table-folded-content" style={{ padding: '8px 12px' }}>
      <Table
        title=""
        columns={innerColumns}
        data={innerRows}
        pagination={false}
        noTableHead={false}
        dense
      />
    </div>
  );
};

export default MessageExpandableRow;
